import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryConfig } from '@src/lib/api'
import { OffsetQueryRequestDto, OffsetResponseDto } from '@src/types/api'
import { INotification } from '@src/types/notifications'
import { dtoToUrlParams } from '@utils/url'
import { Dealer } from '@src/types/dealers'

export const notificationsApi = createApi({
  reducerPath: 'notificationsApi',
  baseQuery: baseQueryConfig('/notifications'),
  tagTypes: [ 'NOTIFICATIONS' ],
  endpoints: build => ({
    getNotifications: build.query<
      OffsetResponseDto<INotification>,
      OffsetQueryRequestDto
    >({
      query: (params) => ({ url: `/?${dtoToUrlParams(params)}` }),
      providesTags: (r: OffsetResponseDto<INotification> | undefined, error) => ([
        ...(error || !r ? [] : r.result).map(({ _id: id }) => ({ type: 'NOTIFICATIONS' as const, id })),
        { type: 'NOTIFICATIONS', id: 'LIST' }
      ])
    }),
    deleteNotification: build.mutation<{ existsNotifications: boolean }, string>({
      query: (notificationId: string) => ({
        url: `/${notificationId}`,
        method: 'DELETE'
      }),
    }),
    changeNotificationSettings: build.mutation<Dealer, {
      email_notification: boolean;
      tg_notification: boolean;
    }>({
      query: (body) => ({
        url: '/settings',
        method: 'POST',
        body
      }),
    }),
  })
})

export const {
  useGetNotificationsQuery,
  useDeleteNotificationMutation,
  useChangeNotificationSettingsMutation
} = notificationsApi